import { getJiraRenderOptions } from "../../connections/atlassian/jira/jira.util";
import { isJira } from "../../connections/atlassian/ap";

export const getConnectionOptions = (renderOptions) => {
  //Add connection specific options here
  if (isJira()) {
    //change to isJira
    return getJiraRenderOptions(renderOptions);
  }
};
